module.exports = __webpack_public_path__ + "img/recording_icon.a9667099.svg";